import {Component, Input} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'inventory-result-waffle',
  templateUrl: './inventory-result-waffle.component.html',
  styles: []
})
export class InventoryResultWaffleComponent extends ExcTranslation {

  @Input() result;
  constructor(private excDss: DefaultSettingsService) {
   super();
  }
}
